// component/modal/shime
import { memo } from 'react';

import ApproachLocale from 'locale/en/approach.json';
import LegacyImage from 'next/legacy/image';
import Url from 'lib/siteurls';
import cloudinaryLoader from 'lib/image/cloudinary-loader';
import { createGlobalStyle } from 'styled-components';

const imgSvg = `${Url.cloudinary}/fl_sanitize/svg/`;
const imgUrlAp = '/c_fill,g_auto,f_auto/approach/';

const ModalShimeStyles = createGlobalStyle`
#modal-shime {
  .body {
    max-width: 100%;
    width: 650px;
    margin: 0 auto;
    padding: 0 0 200px 0;
    display: block;
  }
  .blurb {
    display: block;
    margin-top: 0;
  }
  .blurb img {
    width: 100%;
  }
  .blurb p {
    display: block;
    margin: var(--spacing-48) 0 0;
  }
  .blurb p:nth-child(3) {
    margin: var(--spacing-24) 0 var(--spacing-48);
  }
  .blurb p:nth-child(5) {
    margin: 100px 0;
  }
  .img-wrap {
    margin-top: 40px;
  }
}
`;

const ModalShime = () => (
  <>
    <ModalShimeStyles />
    <div className='head'>
      <p>{ApproachLocale.approach}</p>
      <span>{ApproachLocale.shime_r}</span>
    </div>
    <div className='body'>
      <div className='blurb'>
        <LegacyImage
          src={`${imgUrlAp}/image_how_it_works`}
          width={1200}
          height={677}
          alt={ApproachLocale.shime_r}
          loader={cloudinaryLoader}
        />

        <p className='mb4'>{ApproachLocale.at_the_three}</p>
        <div className='img-wrap'>
          <LegacyImage
            src={`${imgSvg}/shime-graph-1.svg`}
            width={1200}
            height={677}
            alt={ApproachLocale.shime_r}
            loader={cloudinaryLoader}
          />
        </div>
        <div className='img-wrap'>
          <LegacyImage
            src={`${imgSvg}/shime-graph-3.svg`}
            width={1200}
            height={677}
            alt={ApproachLocale.shime_r}
            loader={cloudinaryLoader}
          />
        </div>
      </div>
    </div>
  </>
);

export default memo(ModalShime);
